function updateProductBundlesNew(product, productVariant){
  const $=window.jQuery;
  const DEBUG=(()=>{try{return new URLSearchParams(location.search||'').get('debug_bundles')==='1';}catch{return false;}})();
  if(!$){console.error('[Bundles] jQuery not found');return;}
  if(!window.Shopify||!(Shopify.api&&Shopify.api.formatMoney))console.warn('[Bundles] Shopify.api.formatMoney missing');

  window.prepareBundleFormForShopifyAnalytics=window.prepareBundleFormForShopifyAnalytics||function(){};
  window.trackBundleSubmitSafe=window.trackBundleSubmitSafe||function(){};

  const log=DEBUG?(...a)=>console.log(...a):()=>{};
  const warn=(...a)=>console.warn(...a);
  const group=DEBUG?(l)=>{try{console.group(l);}catch{}}:()=>{};
  const groupEnd=DEBUG?()=>{try{console.groupEnd();}catch{}}:()=>{};
  const time=DEBUG?(l)=>{try{console.time(l);}catch{}}:()=>{};
  const timeEnd=DEBUG?(l)=>{try{console.timeEnd(l);}catch{}}:()=>{};
  function dbg(step,extra){try{window.__bundles_debug_last={t:Date.now(),step,extra};}catch{} log('[Bundles][DBG]',step,extra||'');}
  const S=v=>(v==null?'':String(v));

  /* small helpers */
  function getDataFirst($el, keys, fallback){
    for(let i=0;i<keys.length;i++){
      const v=$el.data(keys[i]);
      if(v!=null && String(v).trim()!=='') return v;
    }
    return fallback;
  }

  

  /* UI helpers */
  function syncCustomUI($sel){
    try{
      const opt=$sel.find('option:selected'); const text=(opt.text()||'').trim(); const val=String(opt.val());
      const root=$sel.closest('.flavor-selection, .flavor-selector').get(0) || $sel.parent().get(0) || $sel.get(0).parentNode;

      const ns=$sel.next('.nice-select');
      if(ns.length){
        const cur=ns[0].querySelector('.current'); if(cur) cur.textContent=text;
        ns[0].querySelectorAll('li').forEach(li=>{
          const v=String(li.getAttribute('data-value')||''); const sel=(v===val);
          li.classList.toggle('selected',sel); li.setAttribute('aria-selected', sel?'true':'false');
        });
      }

      let cs=$sel.siblings('.CustomSelect, .custom-select, .select, .select-wrapper');
      if(!cs.length && root){
        const n=root.querySelector('.CustomSelect, .custom-select, .select, .select-wrapper');
        if(n) cs=$(n);
      }
      if(!cs.length){
        cs=$sel.next('.CustomSelect, .custom-select, .select, .select-wrapper');
      }
      if(cs.length){
        const head=cs[0].querySelector('.CustomSelect__Current, .current, .selected, .select__value, .custom-select__trigger, [data-selected-label]');
        if(head){ head.textContent=text; head.setAttribute('data-value',val); }
        (cs[0].querySelectorAll('.CustomSelect__Option, [data-value], [data-option-value], [role="option"]')||[]).forEach(el=>{
          const vv=String(el.getAttribute('data-value')||el.getAttribute('data-option-value')||el.getAttribute('value')||'');
          const sel=(vv===val);
          el.classList.toggle('selected',sel);
          el.classList.toggle('is-selected',sel);
          el.setAttribute('aria-selected',sel?'true':'false');
        });
      }

      const ariaHead = (root && (root.querySelector('button[aria-haspopup="listbox"], [role="button"].select__head, [data-select-display]'))) || $sel.next('[data-select-display]').get?.(0);
      if(ariaHead){ ariaHead.textContent=text; ariaHead.setAttribute('data-value',val); }

      const ss=$sel.next('.select-selected'); if(ss.length) ss[0].textContent=text;

      dbg('ui-sync',{id:$sel.attr('id'), text, val});
    }catch(e){ dbg('ui-sync:error',String(e)); }
  }
  function setSwatch($sel){
    const $lbl=$sel.closest('.flavor-selection').children('label');
    const opt=$sel.find('option:selected');
    const col=opt.data('color')||opt.data('flavor-color-primary')||null;
    let $sw=$lbl.find('.bundle-color');
    if(!col){ if($sw.length) $sw.remove(); return; }
    $sw.css('background',col);
  }

  function recalcBundleAndRender($bp){
    try{
      const $form = $bp.find('form');
      const isAbs = ['true',true,'1',1].includes($bp.data('absolute'));
      const rate  = parseFloat($bp.data('discount'))||0;

      let orig=0, disc=0;
      $form.find('select.bundle-variant-select').each(function(){
        const opt=$(this).find('option:selected');
        orig += (parseFloat(opt.data('price'))||0)*100;
        disc += (parseFloat(opt.data('discount'))||0)*100;
      });

      // savings-prefix читаем с контейнера слота, чтобы не ломать локализацию
      const $slot = $bp.closest('#ProductBundles2, #ProductBundles1');
      const savingsPrefix = getDataFirst($slot, ['savings-prefix'], 'Spare');

      const discountText = isAbs
        ? Shopify.api.formatMoney(Math.ceil(Math.max(0,orig-disc)), window.theme.moneyFormat)
        : Math.ceil(rate*100)+'%';

      $bp.find('.price-original').html(Shopify.api.formatMoney(orig, window.theme.moneyFormat));
      $bp.find('.price-current').html(Shopify.api.formatMoney(disc, window.theme.moneyFormat));
      $bp.find('.unit-price').html(calcUnitPriceText(disc, $form));

      toggleDiscountUI($bp, orig, disc, discountText, savingsPrefix);
    }catch(e){ warn('[Bundles] recalcBundleAndRender', e); }
  }


  /* PRESELECT */
  function syncSelectOnce($sel, desired, src){
    desired=S(desired);
    const before=S($sel.val());
    const hasOpt=$sel.find('option[value="'+desired.replace(/"/g,'\\"')+'"]').length>0;

    if(hasOpt && before!==desired){
      $sel.val(desired);
      $sel.find('option').prop('selected',false)
           .filter('[value="'+desired.replace(/"/g,'\\"')+'"]').prop('selected',true);
    }

    setSwatch($sel); syncCustomUI($sel);

    const after=S($sel.val());
    if(before!==after){
      try{$sel.trigger('change');}catch{}
      try{$sel.trigger('input');}catch{}
      try{$sel[0].dispatchEvent(new Event('change',{bubbles:true}));}catch{}
      try{$sel[0].dispatchEvent(new Event('input',{bubbles:true}));}catch{}
      dbg('preselect:changed',{src,before,after});
      return true;
    }
    dbg('preselect:noop',{src,desired,kept:after});
    return false;
  }
  function setupPreselect($root,data){
    const $sels=$root.find('select.bundle-variant-select'); if(!$sels.length) return;
    const desired=[]; $sels.each(function(i){
      desired[i]=data?.defaultVariantIds?.[i]!=null ? S(data.defaultVariantIds[i]) : S($(this).find('option:first').val()||'');
    });

    const timers=[];
    const tryAll=(src)=>{ let any=false; $sels.each(function(i){ if(syncSelectOnce($(this),desired[i],src)) any=true; }); return any; };

    tryAll('initial');

    [80,160,320,640,1000,1400].forEach(ms=>timers.push(setTimeout(()=>{ if(!tryAll('retry@'+ms)) dbg('preselect:retry-nochange',ms); },ms)));

    let mo,last=0;
    const onMut=()=>{ const now=Date.now(); if(now-last<60) return; last=now; tryAll('MO'); };
    try{ mo=new MutationObserver(onMut); mo.observe($root[0],{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']}); }catch{}

    timers.push(setTimeout(()=>{ tryAll('final'); if(mo) try{mo.disconnect();}catch{} while(timers.length) clearTimeout(timers.pop()); dbg('preselect:done'); }, 2000));
  }

  /* Theme colors + swatch */
  function getBundleCssVars(){
    const probe=document.querySelector('select[style*="--color-primary"], .flavor-selector[style*="--color-primary"], .product-form [style*="--color-primary"]');
    if(probe?.getAttribute('style')) return probe.getAttribute('style');
    const cs=getComputedStyle(document.documentElement);
    const p=cs.getPropertyValue('--color-primary').trim();
    const s=cs.getPropertyValue('--color-secondary').trim();
    const acc=[]; if(p) acc.push('--color-primary:'+p); if(s) acc.push('--color-secondary:'+s);
    return acc.length?acc.join(';')+';':'';
  }
  const BUNDLE_CSS_VARS=getBundleCssVars();
  function applyCssVarsToBundle($scope){
    if(!BUNDLE_CSS_VARS) return;
    $scope.find('.flavor-selector, select.bundle-variant-select').each(function(){
      const cur=this.getAttribute('style')||''; if(!/--color-primary/.test(cur)) this.setAttribute('style',(cur?cur+'; ':'')+BUNDLE_CSS_VARS);
    });
  }

  const CSS_NAMES=new Set(['black','white','red','green','blue','yellow','cyan','magenta','grey','gray','silver','maroon','olive','lime','teal','navy','fuchsia','purple','orange','brown','beige','coral','crimson','gold','indigo','khaki','lavender','plum','salmon','tan','tomato','turquoise','violet']);
  const RGX_HEX=/#(?:[0-9a-fA-F]{3,4}){1,2}\b/;
  const RGX_RGB=/rgba?\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)/i;
  function extractColor(str){ if(!str||typeof str!=='string')return null; const m=str.match(RGX_HEX)||str.match(RGX_RGB); if(m) return m[0]; const w=str.match(/\b[a-zA-Z]{3,20}\b/g); if(w){for(let i=0;i<w.length;i++){const t=w[i].toLowerCase(); if(CSS_NAMES.has(t)) return t;}} return null; }
  (function(){const id='bundle-swatch-css'; if(document.getElementById(id))return; const css='.bundle-color{width:18px;height:18px;border-radius:9999px;border:1px solid rgba(0,0,0,.15);display:inline-block;vertical-align:middle;margin-left:8px}.flavor-selection>label{display:inline-flex;align-items:center;gap:.25rem}'; const st=document.createElement('style'); st.id=id; st.textContent=css; document.head.appendChild(st);})();

  /* Money / unit price */
  function fm(cents){ try{const fmt=(window.theme&&window.theme.moneyFormat)||'{{amount}}'; return Shopify.api.formatMoney(Math.ceil(cents),fmt);}catch{return (Math.ceil(cents)/100).toFixed(2);} }
  function calcUnitPriceText(total,$form){
    let g=0,ml=0; $form.find('select.bundle-variant-select').each(function(){const opt=$(this).find('option:selected'); g+=parseInt(opt.data('weight-g')||0,10); ml+=parseInt(opt.data('volume-ml')||0,10);});
    if(g>0){ if(g>=250){const perKg=total*1000/g; return 'inkl. MwSt., '+fm(perKg)+' / 1kg';} const per100=total*1000/g/10; return 'inkl. MwSt., '+fm(per100)+' / 100g'; }
    if(ml>0){ if(ml>=250){const perL=total*1000/ml; return 'inkl. MwSt., '+fm(perL)+' / 1L';} const per100ml=total*1000/ml/10; return 'inkl. MwSt., '+fm(per100ml)+' / 100ml'; }
    return '';
  }

  /* Discount UI toggler */
  function toggleDiscountUI($root, origCents, discCents, discountText, savingsPrefix){
    const has = Number(origCents) > Number(discCents);
    $root.toggleClass('has-discount', has);

    const $orig   = $root.find('.price-original');
    const $badge  = $root.find('.discount-badge');
    const $saveAll= $root.find('.bundle-savings');

    if(has){
      const diff = Math.max(0, Number(origCents) - Number(discCents));
      const fmtDiff = Shopify.api.formatMoney(Math.ceil(diff), (window.theme && window.theme.moneyFormat) || '{{amount}}');
      $orig.show().attr('aria-hidden','false');
      $badge.show().text('-' + (discountText||''));
      $saveAll.each(function(){
        this.style.display='';
        this.innerHTML = (savingsPrefix||'Spare') + ' ' + (discountText||'') + ' - ' + fmtDiff;
      });
    }else{
      $orig.hide().attr('aria-hidden','true');
      $badge.hide();
      $saveAll.each(function(){ this.style.display='none'; });
    }
  }

// проставить _bundle_id/_bundle_no всем строкам бандла в корзине
async function enforceBundlePropsOnServer(bundleId, bundleNo){
  try{
    const want = {};
    if (bundleId) want['_bundle_id'] = String(bundleId);
    if (bundleNo)  want['_bundle_no'] = String(bundleNo);
    if (!Object.keys(want).length) return;

    const cart = await fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json()).catch(()=>({items:[]}));
    // последовательные апдейты, чтобы Shopify не "терял" часть запросов
    for (const it of (cart.items||[])) {
      const p = it.properties || {};
      const isOur =
        (bundleId && String(p.bundle_id||p.bundleid||'') === String(bundleId)) ||
        (bundleNo  && String(p.bundle_no ||'')           === String(bundleNo));

      if (!isOur || !it.key) continue;

      const needFix =
        (want._bundle_id && String(p._bundle_id||'') !== String(want._bundle_id)) ||
        (want._bundle_no && String(p._bundle_no||'') !== String(want._bundle_no));

      if (!needFix) continue;

      const nextProps = Object.assign({}, p, want);
      await fetch('/cart/change.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({ id: it.key, properties: nextProps })
      }).catch(()=>{});
    }
  }catch(e){ console.warn('[Bundles] enforceBundlePropsOnServer', e); }
}



  /* Drawer helpers */
  const _qs=s=>document.querySelector(s);
  function _getDrawerEl(sel){return sel?_qs(sel):_qs('#sidebar-cart')||_qs('#shopify-section-sidebar-cart .Drawer')||_qs('#sidebar-cart .Drawer')||_qs('cart-drawer,[data-cart-drawer],.cart-drawer,drawer-cart,#CartDrawer,#cart-drawer')||_qs('.minicart,#minicart,.mini-cart,#mini-cart,.sidecart,#sidecart');}
  function bindOverlayClickOnce(){const ov=document.querySelector('.PageOverlay'); if(!ov||ov.__bundlesBound) return; ov.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();closeCartDrawerAdvanced('#sidebar-cart');}); ov.__bundlesBound=true;}
  function bindDrawerCloseButtonsOnce(root){const d=root||_getDrawerEl('#sidebar-cart')||_getDrawerEl(); if(!d||d.__bundlesCloseBound) return; const sel=['[data-action="close-drawer"]','[data-drawer-close]','.Drawer__Close','.drawer__close','[aria-label="Close"], [aria-label="Schließen"], [aria-label="Close cart"], [aria-label*="close"]'].join(','); d.addEventListener('click',e=>{const btn=e.target.closest&&e.target.closest(sel); if(!btn) return; e.preventDefault(); e.stopPropagation(); closeCartDrawerAdvanced('#sidebar-cart');},true); d.__bundlesCloseBound=true;}
  function openCartDrawerAdvanced(sel){const d=_getDrawerEl(sel); if(d){try{d.setAttribute('aria-hidden','false'); d.removeAttribute('inert');}catch{} if(typeof d.open==='function')try{d.open();}catch{} if('open'in d)try{d.open=true;}catch{} d.setAttribute('open',''); d.classList.add('is-open','active','drawer--is-open','is-visible','open'); document.querySelector('.PageOverlay')?.classList.add('is-visible'); document.documentElement.classList.add('overflow-hidden','no-scroll'); document.body.classList.add('overflow-hidden','no-scroll'); bindOverlayClickOnce(); bindDrawerCloseButtonsOnce(d); return true;} const t=_qs('[data-cart-drawer-toggle],[data-open-cart],[data-action="open-cart"],[aria-controls*="CartDrawer"],[href="#CartDrawer"],.js-open-cart-drawer,.header__icon--cart a,.site-header__cart,.cart-toggle,.header__icon--cart button'); if(t){t.click(); return true;} return false;}
  function closeCartDrawerAdvanced(sel){const d=_getDrawerEl(sel); let ok=false; if(d){ if('open'in d)try{d.open=false;}catch{} d.removeAttribute('open'); d.setAttribute('aria-hidden','true'); d.classList.remove('is-open','active','drawer--is-open','is-visible','open'); ok=true;} document.querySelector('.PageOverlay')?.classList.remove('is-visible'); document.documentElement.classList.remove('overflow-hidden','no-scroll'); document.body.classList.remove('overflow-hidden','no-scroll'); if(!ok){const btn=document.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]'); if(btn)try{btn.click(); ok=true;}catch{}} return ok;}
  function refreshThemeCartUI(){try{document.dispatchEvent(new CustomEvent('cart:refresh'));}catch{} try{document.dispatchEvent(new CustomEvent('ajaxProduct:added'));}catch{} try{document.dispatchEvent(new CustomEvent('cart:updated'));}catch{} try{document.dispatchEvent(new CustomEvent('cart:change'));}catch{} try{if(window.theme?.init) window.theme.init();}catch{} try{if(window.Shopify?.theme?.sectionsReload) Shopify.theme.sectionsReload();}catch{} bindOverlayClickOnce(); bindDrawerCloseButtonsOnce();}
  function updateCartCountBubble(){return fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json()).then(cart=>{const cnt=typeof cart?.item_count==='number'?cart.item_count:null; if(cnt==null) return; document.querySelectorAll('[data-cart-count], .header__cart-count, .cart-count-bubble, [aria-label*="Cart"] .count, .Header__CartCount').forEach(el=>{el.textContent=String(cnt); el.setAttribute?.('data-count',String(cnt)); if(cnt>0){el.classList.remove('is-empty','hidden'); el.removeAttribute('hidden');} else {el.classList.add('is-empty');}});}).catch(e=>warn('[Bundles] updateCartCountBubble failed',e));}

  /* Guards */
  let __guardActive=false,__unsubs=[];
  function forceDrawerPreference(){try{if(window.theme?.settings){if('cartType'in window.theme.settings) window.theme.settings.cartType='drawer'; if('cart_type'in window.theme.settings) window.theme.settings.cart_type='drawer';} if(window.Shopify?.routes) Shopify.routes.cart_url='/cart'; if(window.theme?.cart){if('redirectToCart'in window.theme.cart) window.theme.cart.redirectToCart=false; if('cartType'in window.theme.cart) window.theme.cart.cartType='drawer';} const b=document.body; if(b?.dataset){if(b.dataset.cartType) b.dataset.cartType='drawer'; if(b.dataset.ajaxCart) b.dataset.ajaxCart='true';}}catch{}}
  function installRedirectGuards(){if(__guardActive) return; __guardActive=true; forceDrawerPreference(); const isClose=t=>!!(t&&(t.closest('[data-action="close-drawer"]')||t.closest('[data-drawer-close]')||t.closest('.Drawer__Close')||t.closest('.drawer__close')||t.closest('[aria-label="Close"], [aria-label="Schließen"], [aria-label="Close cart"], [aria-label*="close"]'))); const onSubmit=e=>{try{const f=e.target; if(!f||f.nodeName!=='FORM') return; const a=(f.getAttribute('action')||'')+''; if(/\/cart(?:\/add)?/i.test(a)){e.preventDefault(); e.stopPropagation(); dbg('guard:block submit',a);}}catch{}}; const onClick=e=>{try{if(isClose(e.target))return; const a=e.target.closest?.('a[href]'); if(!a) return; const href=a.getAttribute('href')||''; if(/\/cart(?:[\?#].*)?$/i.test(href)||/[?&]view=cart/i.test(href)){e.preventDefault(); e.stopPropagation(); dbg('guard:block link',href);}}catch{}}; document.addEventListener('submit',onSubmit,true); document.addEventListener('click',onClick,true); __unsubs.push(()=>{document.removeEventListener('submit',onSubmit,true); document.removeEventListener('click',onClick,true);}); const onAdded=()=>dbg('guard:ajaxProduct:added'); document.addEventListener('ajaxProduct:added',onAdded,true); __unsubs.push(()=>document.removeEventListener('ajaxProduct:added',onAdded,true));}
  function removeRedirectGuardsSoon(){setTimeout(()=>{while(__unsubs.length) try{__unsubs.pop()();}catch{} __guardActive=false;},1200);}

  /* Drawer skeleton + totals */
  function bootstrapDrawerSkeleton(root){let d=root||document.querySelector('#sidebar-cart')||document.querySelector('.Drawer'); if(!d) return null; let f=d.querySelector('form.Cart.Drawer__Content'); if(!f){f=document.createElement('form'); f.className='Cart Drawer__Content'; f.method='post'; f.action='/cart'; d.appendChild(f);} let m=f.querySelector('.Drawer__Main'); if(!m){m=document.createElement('div'); m.className='Drawer__Main'; m.setAttribute('data-scrollable',''); f.appendChild(m);} let c=m.querySelector('.Drawer__Container'); if(!c){c=document.createElement('div'); c.className='Drawer__Container'; m.appendChild(c);} let list=c.querySelector('.Cart__ItemList'); if(!list){list=document.createElement('div'); list.className='Cart__ItemList'; c.appendChild(list);} f.querySelector('.Cart__Empty')?.remove(); bindDrawerCloseButtonsOnce(d); return d;}
  function ensureShippingBanner(container){if(container.querySelector('.Drawer__Container--shipping'))return; const w=document.createElement('div'); w.className='Drawer__Container--shipping'; w.innerHTML='<div class="Cart__ShippingInfo">Gute Wahl! Auf Lager. In 1-3 Tagen bei dir</div>'; container.prepend(w);}
  function ensureMainContainer(f){let m=f.querySelector('.Drawer__Main'); if(!m){m=document.createElement('div'); m.className='Drawer__Main'; m.setAttribute('data-scrollable',''); while(f.firstChild) m.appendChild(f.firstChild); f.appendChild(m);} let c=m.querySelector('.Drawer__Container'); let l=m.querySelector('.Cart__ItemList'); if(!c){c=document.createElement('div'); c.className='Drawer__Container'; if(l){m.insertBefore(c,l); c.appendChild(l);} else m.appendChild(c);} else if(l && l.parentElement!==c){c.appendChild(l);} ensureShippingBanner(m); return {m,c};}
  function footerSVGPayments(){return '<svg width="342" height="18" viewBox="0 0 342 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity=".07" d="M85.7 0H61.3C60 0 59 1 59 2.25V15.75C59 17.03 60.07 18 61.29 18H85.71C87 18 88 17.03 88 15.75V2.25C88 1 86.93 0 85.71 0Z" fill="#545252"/></svg>'; }
  function placeFooterAfterMain(d,footer){const f=d.querySelector('form.Cart.Drawer__Content')||d; const m=f.querySelector('.Drawer__Main'); if(!m) return; if(footer.parentNode!==f||footer.previousElementSibling!==m) f.insertBefore(footer,m.nextSibling);}
  function renderFooterHTML(cart){const thr=window.freeShippingThresholdCents||6000; const total=typeof cart?.total_price==='number'?cart.total_price:0; const rem=Math.max(0,thr-total); const pct=thr?Math.max(0,Math.min(100,Math.round(total*100/thr))):0; const freeHidden=rem>0?'':'style="display:none"'; const notFreeHidden=rem>0?'style="display:none"':''; return `<div class="Cart__Threshold"><div class="Cart__Threshold_Container"><h3><span class="Cart__Threshold_Message Cart__FreeShippingMessage" ${freeHidden}>Nur noch <strong class="Cart__Threshold_Amount" data-money-convertible data-total="${total}">${fm(rem)}</strong> zum kostenfreien Versand.</span><span class="Cart__Threshold_Message Cart__NotFreeShippingMessage" ${notFreeHidden}>Du hast kostenfreien Versand!</span></h3><div class="Cart__Threshold_ProgressBar"><div class="Cart__Threshold_ProgressBar_Bar" data-cart-total="${total}" style="width:${pct}%;"></div></div></div></div><div class="Cart__Total"><div class="Cart__Total_Label">Zwischensumme</div><span data-money-convertible class="Price">${fm(total)}</span></div><div class="Cart__Total"><div class="Cart__Total_Label">Gesamtsumme (inkl. MwSt.)</div><span data-money-convertible class="Price">${fm(total)}</span></div><button type="submit" name="cart" class="Cart__Checkout Button Button--primary Button--full"><span>Jetzt sicher zur Кasse</span></button><div class="Cart__PaymentMethods">${footerSVGPayments()}</div>`;}
  function attachFooterHandlers(d){try{const f=d.querySelector('.Drawer__Footer'); if(!f) return; const b=f.querySelector('.Cart__Checkout'); if(!b||b.__bundlesBound) return; b.addEventListener('click',e=>{e.preventDefault(); e.stopPropagation(); try{location.href='/cart';}catch{} return false;}); b.__bundlesBound=true;}catch(e){warn('[Bundles] attachFooterHandlers',e);}}
  function ensureFooterWithTotals(d,reason){try{d=bootstrapDrawerSkeleton(d)||d||document.querySelector('#sidebar-cart')||document.querySelector('.Drawer'); if(!d) return; const f=d.querySelector('form.Cart.Drawer__Content')||d; ensureMainContainer(f); let footer=d.querySelector('.Drawer__Footer'); if(!footer){footer=document.createElement('aside'); footer.className='Drawer__Footer'; footer.setAttribute('data-drawer-animated-bottom',''); const m=f.querySelector('.Drawer__Main'); (m?f.insertBefore(footer,m.nextSibling):d.appendChild(footer));} else placeFooterAfterMain(d,footer); time('[footer] /cart.js'); fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json()).then(cart=>{timeEnd('[footer] /cart.js'); footer.innerHTML=renderFooterHTML(cart||{total_price:0}); placeFooterAfterMain(d,footer); attachFooterHandlers(d); bindDrawerCloseButtonsOnce(d); setTimeout(()=>{ if(!d.contains(footer)) ensureFooterWithTotals(d,'recover'); else placeFooterAfterMain(d,footer); },300);}).catch(err=>{timeEnd('[footer] /cart.js'); warn('[Bundles] totals fetch fail',err); footer.innerHTML=renderFooterHTML({total_price:0}); placeFooterAfterMain(d,footer); attachFooterHandlers(d); bindDrawerCloseButtonsOnce(d);});}catch(e){warn('[Bundles] ensureFooterWithTotals',e);} }

  /* Ensure .CartItem__PriceList in drawer (no-dup) */
  function ensureDrawerPriceList(item){
    try{
      const info=item.querySelector('.CartItem__Info');
      if(!info) return;

      const lineBlock=item.querySelector('.CartItem__LinePriceList');
      if(lineBlock) return;

      let list=info.querySelector('.CartItem__PriceList');
      if(list){ list.classList.add('CartItem__PriceList--drawer'); return; }

      const line=item.querySelector('.CartItem__LinePrice .Price, .CartItem__LinePriceList .Price, .CartItem__Price .Price');
      const html=line?line.innerHTML:'';
      list=document.createElement('div');
      list.className='CartItem__PriceList CartItem__PriceList--drawer';
      if(html){
        const span=document.createElement('span');
        span.className='CartItem__Price Price';
        span.setAttribute('data-money-convertible','');
        span.innerHTML=html;
        list.appendChild(span);
      }
      const title=info.querySelector('.CartItem__Title, h3, h4');
      if(title&&title.nextSibling) info.insertBefore(list,title.nextSibling); else info.appendChild(list);
    }catch(e){warn('[Bundles] ensureDrawerPriceList',e);}
  }
  
  /* Normalize drawer (+ anti-dup) */
  function normalizeDrawerMarkup(root){
    try{
      let d=root||document.querySelector('#sidebar-cart'); if(!d) return;
      d=bootstrapDrawerSkeleton(d)||d;
      const f=d.querySelector('form.Cart.Drawer__Content')||d;
      f.querySelectorAll('img.CartItem__Image[src*="shopifypreview.com"]').forEach(img=>{img.src=img.src.replace(/\/\/[^/]*shopifypreview\.com/,'//www.rockanutrition.de');});
      const hasItems=!!f.querySelector('.Cart__ItemList .CartItem'); if(hasItems) f.querySelector('.Cart__Empty')?.remove();
      ensureMainContainer(f); f.querySelectorAll('.Cart__Head.hidden-phone').forEach(n=>n.remove());

      f.querySelectorAll('.CartItem').forEach(item=>{
        const actions=item.querySelectorAll('.CartItem__Actions');
        if(actions.length>1){ const [a,b]=actions; a?.querySelectorAll('.CartItem__Remove').forEach(n=>n.remove()); b?.querySelectorAll('.QuantitySelector, .CartItem__QuantitySelector').forEach(n=>n.remove()); }

        ensureDrawerPriceList(item);

        const topList=item.querySelector('.CartItem__Info .CartItem__PriceList--drawer, .CartItem__Info .CartItem__PriceList');
        const bottomList=item.querySelector('.CartItem__LinePriceList');
        if(topList && bottomList){ topList.remove(); }

        const lineLists=item.querySelectorAll('.CartItem__LinePriceList');
        if(lineLists.length>1){
          for(let i=0;i<lineLists.length-1;i++) lineLists[i].remove();
        }
      });

      ensureFooterWithTotals(d,'normalize'); bindDrawerCloseButtonsOnce(d);
      document.querySelector('.PageOverlay')?.classList.add('is-visible');
      d.classList.remove('is-empty'); document.documentElement.classList.add('overflow-hidden','no-scroll'); document.body.classList.add('overflow-hidden','no-scroll');
    }catch(e){warn('[Bundles] normalizeDrawerMarkup',e);}
  }

  /* Sections refresh / fallbacks */
  const routesCartUrl=()=> (window.routes?.cart_url)||'/cart';
  const CACHE_SECTIONS_KEYS='sidebar-cart,cart-icon-bubble';
  let __cartSectionsCache=null, __cartWarmPromise=null;

  async function warmCartSections(){
    try{
      if(__cartSectionsCache||__cartWarmPromise) return __cartWarmPromise;
      const path=(location.pathname+location.search)||'/';
      const u=`${routesCartUrl()}?sections=${encodeURIComponent(CACHE_SECTIONS_KEYS)}&sections_url=${encodeURIComponent(path)}`;
      dbg('warm:fetch',u);
      __cartWarmPromise=fetch(u,{credentials:'same-origin'})
        .then(r=>r.json())
        .then(json=>{ __cartSectionsCache=json; dbg('warm:ready',{keys:Object.keys(json||{})}); return json; })
        .catch(e=>{ dbg('warm:error',String(e)); return null; })
        .finally(()=>{ __cartWarmPromise=null; });
      return __cartWarmPromise;
    }catch(e){ dbg('warm:fail',String(e)); return null; }
  }

  function applySectionsCacheIfAny(){
    if(!__cartSectionsCache) return false;
    try{
      replaceSectionsFromAddResponse(__cartSectionsCache);
      let d=_getDrawerEl('#sidebar-cart')||_getDrawerEl();
      if(d){ d=bootstrapDrawerSkeleton(d)||d; normalizeDrawerMarkup(d); ensureFooterWithTotals(d,'warm-cache'); bindDrawerCloseButtonsOnce(d); }
      dbg('warm:applied');
      return true;
    }catch(e){ dbg('warm:apply:error',String(e)); return false; }
  }

  async function refreshCartDrawerFromCartSection(){
    dbg('refreshCartDrawerFromCartSection:start');

    applySectionsCacheIfAny();

    const ids=['cart','sidebar-cart','cart-icon-bubble']; const path=(location.pathname+location.search)||'/'; const cartUrl=routesCartUrl();
    const qs=s=>document.querySelector(s); const parse=s=>{try{return(new DOMParser()).parseFromString(s,'text/html');}catch{return null;}};
    async function fetchBatched(base){const u=base+'?sections='+encodeURIComponent(ids.join(','))+'&sections_url='+encodeURIComponent(path); try{const r=await fetch(u,{credentials:'same-origin'}); try{return JSON.parse(await r.text());}catch{return{};}}catch{return{};}}
    async function fetchById(base,id){try{const r=await fetch(base+'?section_id='+encodeURIComponent(id),{credentials:'same-origin'}); return await r.text();}catch{return'';}}
    let sections=Object.assign({},await fetchBatched(cartUrl),await fetchBatched(path));
    if(!sections['cart'])sections['cart']=await fetchById(path,'cart');
    if(!sections['sidebar-cart'])sections['sidebar-cart']=await fetchById(path,'sidebar-cart');
    if(!sections['cart-icon-bubble'])sections['cart-icon-bubble']=await fetchById(path,'cart-icon-bubble');
    if(!sections['cart'])sections['cart']=await fetchById(cartUrl,'cart');
    if(!sections['sidebar-cart'])sections['sidebar-cart']=await fetchById(cartUrl,'sidebar-cart');
    if(!sections['cart-icon-bubble'])sections['cart-icon-bubble']=await fetchById(cartUrl,'cart-icon-bubble');

    let target=qs('#sidebar-cart')||qs('.Drawer'); if(!target) return false;
    target=bootstrapDrawerSkeleton(target)||target;

    const docCart=sections['cart']?parse(sections['cart']):null;
    const docSide=sections['sidebar-cart']?parse(sections['sidebar-cart']):null;

    function pickIncomingForm(doc){return doc?.querySelector('#sidebar-cart form.Cart.Drawer__Content')||doc?.querySelector('form.Cart.Drawer__Content')||null;}
    const incForm=pickIncomingForm(docSide)||pickIncomingForm(docCart);

    if(incForm){
      const tgt=target.querySelector('form.Cart.Drawer__Content')||target; tgt.innerHTML=incForm.innerHTML;
      if(sections['cart-icon-bubble']){const d=parse(sections['cart-icon-bubble']); const src=d&&(d.querySelector('#cart-icon-bubble,[data-section-id="cart-icon-bubble"]')||d.body.firstElementChild); const dst=qs('#cart-icon-bubble,[data-section-id="cart-icon-bubble"],.cart-count-bubble'); if(src&&dst) dst.innerHTML=src.innerHTML;}
      try{await updateCartCountBubble();}catch{} try{refreshThemeCartUI();}catch{}
      normalizeDrawerMarkup(target); ensureFooterWithTotals(target,'after-sections'); bindDrawerCloseButtonsOnce(target);

      __cartSectionsCache = sections;
      return true;
    }

    function pickIncomingRoot(doc){if(!doc) return null; let el=doc.querySelector('#sidebar-cart'); if(!el){const sec=doc.querySelector('#shopify-section-cart,[data-section-id="cart"],#cart'); if(sec) el=sec.querySelector('#sidebar-cart')||sec.querySelector('.Drawer');} if(!el) el=doc.querySelector('#shopify-section-sidebar-cart,[data-section-id="sidebar-cart"],#sidebar-cart,.Drawer'); return el||null;}
    const incoming=pickIncomingRoot(docSide)||pickIncomingRoot(docCart); if(!incoming){try{await updateCartCountBubble();}catch{} return false;}

    const tMain=target.querySelector('.Drawer__Main'), iMain=incoming.querySelector('.Drawer__Main')||incoming;
    const tFooter=target.querySelector('.Drawer__Footer'), iFooter=incoming.querySelector('.Drawer__Footer');
    if(tMain&&iMain) tMain.innerHTML=iMain.innerHTML;
    if(tFooter&&iFooter) tFooter.innerHTML=iFooter.innerHTML;
    if(!tFooter&&iFooter){const form=target.querySelector('form.Cart.Drawer__Content')||target; const main=form.querySelector('.Drawer__Main'); const clone=iFooter.cloneNode(true); (main?form.insertBefore(clone,main.nextSibling):target.appendChild(clone));}
    if(sections['cart-icon-bubble']){const d=parse(sections['cart-icon-bubble']); const src=d&&(d.querySelector('#cart-icon-bubble,[data-section-id="cart-icon-bubble"]')||d.body.firstElementChild); const dst=qs('#cart-icon-bubble,[data-section-id="cart-icon-bubble"],.cart-count-bubble'); if(src&&dst) dst.innerHTML=src.innerHTML;}
    try{await updateCartCountBubble();}catch{} try{refreshThemeCartUI();}catch{}
    normalizeDrawerMarkup(target); ensureFooterWithTotals(target,'after-fallback-sections'); bindDrawerCloseButtonsOnce(target);

    __cartSectionsCache = sections;
    return true;
  }

  async function refreshCartDrawerFallbackFromCartPage(){
    const qs=(s,r)=> (r||document).querySelector(s);
    async function trySidebarSection(url){try{const r=await fetch(url+(url.includes('?')?'&':'?')+'section_id=sidebar-cart',{credentials:'same-origin'}); const html=await r.text(); const doc=new DOMParser().parseFromString(html,'text/html'); const incoming=qs('#sidebar-cart',doc)||qs('#shopify-section-sidebar-cart,[data-section-id="sidebar-cart"],.Drawer',doc); if(!incoming) return false; let target=document.querySelector('#sidebar-cart')||document.querySelector('.Drawer'); if(!target) return false; target=bootstrapDrawerSkeleton(target)||target; const incForm=incoming.querySelector('form.Cart.Drawer__Content')||incoming; const tgtForm=target.querySelector('form.Cart.Drawer__Content')||target; tgtForm.innerHTML=incForm.innerHTML; normalizeDrawerMarkup(target); ensureFooterWithTotals(target,'fallback-side'); bindDrawerCloseButtonsOnce(target); try{refreshThemeCartUI();}catch{} return true;}catch(e){warn('[Bundles] trySidebarSection',e); return false;}}
    if(await trySidebarSection(location.pathname) || await trySidebarSection('/cart')) return true;

    let html=''; try{const r=await fetch('/cart',{credentials:'same-origin'}); html=await r.text();}catch(e){warn('[Bundles] fetch /cart',e); return false;}
    const doc=new DOMParser().parseFromString(html,'text/html'); if(!doc) return false;

    let target=document.querySelector('#sidebar-cart')||document.querySelector('.Drawer'); if(!target) return false;
    target=bootstrapDrawerSkeleton(target)||target;

    const tgtForm=target.querySelector('form.Cart.Drawer__Content')||target; const dstMain=tgtForm.querySelector('.Drawer__Main')||tgtForm;
    const srcList=qs('.Cart__ItemList',doc); const srcTotals=[...doc.querySelectorAll('.Cart__Total')];

    ensureMainContainer(tgtForm);
    const dstList=qs('.Cart__ItemList',tgtForm);
    if(srcList){const clone=srcList.cloneNode(true); if(dstList) dstList.replaceWith(clone); else dstMain.appendChild(clone);}

    ensureFooterWithTotals(target,'fallback-cart-page');
    const footer=target.querySelector('.Drawer__Footer');
    if(footer && srcTotals.length){footer.querySelectorAll('.Cart__Total').forEach(n=>n.remove()); srcTotals.forEach(n=>footer.appendChild(n.cloneNode(true))); placeFooterAfterMain(target,footer);}
    try{await updateCartCountBubble();}catch{} try{refreshThemeCartUI();}catch{}
    normalizeDrawerMarkup(target); ensureFooterWithTotals(target,'fallback-after-normalize'); bindDrawerCloseButtonsOnce(target);
    return true;
  }

  function findSectionCurrent(name){return document.querySelector('#shopify-section-'+name)||document.querySelector('[data-section-id="'+name+'"]')||document.querySelector('#'+name);}
  function findSectionIncoming(wrapper,name){return wrapper.querySelector('#shopify-section-'+name)||wrapper.querySelector('[data-section-id="'+name+'"]')||wrapper.querySelector('#'+name)||wrapper.firstElementChild;}
  function smartReplaceDrawer(targetRoot,incomingRoot){
    if(!targetRoot||!incomingRoot) return false;
    const tMain=targetRoot.querySelector('.Drawer__Main')||targetRoot.querySelector('.Cart__Items')||targetRoot;
    const iMain=incomingRoot.querySelector('.Drawer__Main')||incomingRoot.querySelector('.Cart__Items')||incomingRoot;
    if(!tMain||!iMain) return false;
    tMain.innerHTML=iMain.innerHTML;
    let d=(targetRoot.closest&&targetRoot.closest('#sidebar-cart'))||document.querySelector('#sidebar-cart')||targetRoot;
    d=bootstrapDrawerSkeleton(d)||d; normalizeDrawerMarkup(d); ensureFooterWithTotals(d,'smartReplace'); bindDrawerCloseButtonsOnce(d);
    return true;
  }
  function replaceSectionsFromAddResponse(sections){
    if(!sections) return;
    Object.keys(sections).forEach(name=>{
      const html=sections[name]; if(!html) return;
      const cur=findSectionCurrent(name); if(!cur) return;
      const tmp=document.createElement('div'); tmp.innerHTML=html;
      const inc=findSectionIncoming(tmp,name);
      const ok=smartReplaceDrawer(cur,inc);
      if(!ok){
        cur.innerHTML=inc?inc.innerHTML:html;
        let d=document.querySelector('#sidebar-cart')||document.querySelector('.Drawer');
        if(d){d=bootstrapDrawerSkeleton(d)||d; ensureFooterWithTotals(d,'replaceSections:plain'); bindDrawerCloseButtonsOnce(d);}
      }
    });
    bindOverlayClickOnce();
  }

  /* MAIN */
  group('[Bundles] init'); log('[Bundles] product:',product?.id,'variant:',productVariant?.id);

  $.getJSON('https://shopify.ilpt.de/api/shopify/bundles.js?shop=rocka-nutrition.myshopify.com')
    .done(function(bundles){
      dbg('bundles-loaded',{count:(bundles||[]).length});
      const valid=[];
      (bundles||[]).forEach(bundle=>{
        const now=new Date();
        const ok=((!!bundle.available||Number(bundle.available)===1)&&Number(bundle.product_page)===1&&(!bundle.valid_from||now>=new Date(bundle.valid_from))&&(!bundle.valid_to||now<=new Date(bundle.valid_to)));
        if(!ok) return;

        const availableVariants=[]; const defaultVariantIds=[]; let highlightPrice=0, compareAtPrice=0;

        (bundle.items||[]).forEach((item,i)=>{
          let selected=null;
          (item.variants||[]).forEach(v=>{
            if(v.available){ (availableVariants[i]||(availableVariants[i]=[])).push(v); }
            if(v.selected) selected=v;
          });
          const list=availableVariants[i]||[];
          let defId=null;

          const selAvail=(item?.variants||[]).find(v=>v.selected && v.available);
          if(selAvail){
            const hit=list.find(v=>String(v.id)===String(selAvail.id));
            if(hit) defId=String(hit.id);
          }

          if(!defId && item?.default_variant_id){
            const hit=list.find(v=>String(v.id)===String(item.default_variant_id));
            if(hit) defId=String(hit.id);
          }

          if(!defId && Array.isArray(bundle.default_variant_ids)){
            const idb=bundle.default_variant_ids[i];
            if(idb){
              const hit=list.find(v=>String(v.id)===String(idb));
              if(hit) defId=String(hit.id);
            }
          }

          if(!defId && item?.default_title){
            const norm=String(item.default_title).toLowerCase();
            const by=list.find(v=>String(v.title||'').toLowerCase().includes(norm));
            if(by) defId=String(by.id);
          }

          if(!defId && list.length) defId=String(list[0].id);

          defaultVariantIds[i]=defId;

          if(selected){
            highlightPrice+=Number(selected.price_with_tax_and_discount)*100;
            compareAtPrice+=Number(selected.price_with_tax)*100;
          }
        });

        if(availableVariants.length!==(bundle.items||[]).length) return;

        const discountTextBase=(Number(bundle.absolute)===1||bundle.absolute===true)
          ? fm(Math.ceil(compareAtPrice-highlightPrice))
          : Math.ceil(Number(bundle.discount||0)*100)+'%';

        valid.push({
          id:String(bundle.id),
          priority:Number(bundle.priority)||0,
          absolute:(Number(bundle.absolute)===1||bundle.absolute===true),
          discount:Number(bundle.discount||0),
          discountTextBase,
          discountCode:bundle.discount_code||'',
          rand:Math.floor(1+Math.random()*1e8),
          availableVariants, defaultVariantIds,
          highlightPrice, compareAtPrice,
          link:bundle.link, title:bundle.title, image_src:bundle.image_src
        });
      });

      if(!valid.length){dbg('no-valid-bundles'); groupEnd(); return;}
      valid.sort((a,b)=>(b.priority||0)-(a.priority||0));

      const $slot1=$('#ProductBundles1'), $slot2=$('#ProductBundles2');
      const slots=[ {$el:$slot1,id:($slot1.data('bundle-id')||'').toString().trim(),type:1}, {$el:$slot2,id:($slot2.data('bundle-id')||'').toString().trim(),type:2} ];
      const used=new Set(), pickById=id=>valid.find(b=>b.id===String(id))||null, pickNext=()=>valid.find(b=>!used.has(b.id))||null;

      // === add-to-cart (по селектам, без агрегации, анти-merge через _bundle_row) ===
      async function ajaxAddBundle($form, sectionList){
        const bundleId = String($form.find('input[name="properties[_bundle_id]"]').val()||'').trim();
        const bundleNo = String($form.find('input[name="properties[_bundle_no]"]').val()||'').trim();

        // собираем id вариантов строго из наших селектов (так надёжнее, чем по name="id[]")
        const selects = [].slice.call($form.find('select.bundle-variant-select'));
        const picked  = selects.map(sel => {
          const $sel = $(sel);
          const val  = String($sel.val() || $sel.find('option:selected').val() || '').trim();
          return val;
        }).filter(Boolean);

        // пытаемся прочитать qty для каждой позиции (если нет — 1)
        const qtyInputs = [].slice.call($form.find('[name="qty[]"]'));
        const qtyByIndex = i => {
          const raw = qtyInputs[i] ? parseInt(qtyInputs[i].value, 10) : 1;
          return (isFinite(raw) && raw > 0) ? raw : 1;
        };

        // единые свойства для каждой строки (видимые и скрытые)
        const baseProps = {};
        if (bundleId){
          baseProps.bundle_id   = bundleId;
          baseProps._bundle_id  = bundleId;
          baseProps.bundleid    = bundleId;   // legacy
          baseProps._bundleid   = bundleId;   // legacy
        }
        if (bundleNo){
          baseProps.bundle_no   = bundleNo;
          baseProps._bundle_no  = bundleNo;
        }

        // НЕ агрегируем: каждая выбранная позиция отдельной строкой
        // + _bundle_row чтобы Shopify не схлопывал одинаковые строки
        const items = picked.map((vid, i) => ({
          id: Number(vid),
          quantity: qtyByIndex(i),
          properties: Object.assign({}, baseProps, { _bundle_row: String(i+1) })
        }));

        if (!items.length) throw new Error('[Bundles] Nothing to add: no variants picked');

        const payload = { items };
        if (Array.isArray(sectionList) && sectionList.length){
          payload.sections     = sectionList;
          payload.sections_url = location.pathname;
        }

        installRedirectGuards();
        time('[ajax] add');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify(payload)
        });
        timeEnd('[ajax] add');

        const txt = await res.text();
        if (!res.ok){
          removeRedirectGuardsSoon();
          throw new Error('Add to cart failed: ' + txt);
        }

        let json = {};
        try { json = JSON.parse(txt); } catch {}

        if (json?.sections){
          replaceSectionsFromAddResponse(json.sections);
          __cartSectionsCache = json.sections;
        }

        // После добавления — гарантируем наличие скрытых _bundle_* на всех линиях бандла
        try { await enforceBundlePropsOnServer(bundleId, bundleNo); } catch {}

        return json;
      }


      function buildAndMount(slotIdx,data){
        const slot=slots[slotIdx],$c=slot.$el; if(!$c||!$c.length) return;

        let asLinkRaw=$c.data('cta-as-link');
        let asLink=(asLinkRaw===undefined||asLinkRaw===null)?true:String(asLinkRaw).toLowerCase()!=='false';
        const openDrawer=($c.data('cta-open-drawer')===true)||(String($c.data('cta-open-drawer')).toLowerCase()==='true');
        if(openDrawer) asLink=false;

        const ctaHref = getDataFirst($c, ['cta-href','link','bundle-link'], data.link || '#');
        const drawerSel=$c.data('drawer-selector')||'#sidebar-cart';

        const discovered=['cart','sidebar-cart','cart-icon-bubble'];
        const sectionAttr=($c.data('cart-sections')||'').toString();
        const sectionList=sectionAttr?sectionAttr.split(',').map(s=>s.trim()).filter(Boolean):discovered;

        let html='';
        html+=`<div class="bundle-product" data-bundle-id="${data.id}" data-discount="${data.discount}" data-absolute="${data.absolute?'true':'false'}">`;
        html+=`<form class="bundle-form" autocomplete="off"><div class="bundle-form-container"><div class="flavor-selections-container">`;
        html+=`<input type="hidden" name="properties[_bundle_id]" class="properties" value="${data.rand}">
               <input type="hidden" name="properties[_bundle_no]" class="properties" value="${data.id}">`;

        data.availableVariants.forEach((variants,i)=>{
          const idx=i+1;
          html+=`<div class="flavor-selection"><label for="bundle_${data.id}_select_${idx}">Geschmack ${idx}</label><div class="flavor-selector" style="${BUNDLE_CSS_VARS||''}"><select id="bundle_${data.id}_select_${idx}" name="id[]" class="bundle-variant-select" data-custom-select="true" style="${BUNDLE_CSS_VARS||''}">`;
          variants.forEach(v=>{
            const m=(v.title||'').match(/(\d+(?:[.,]\d+)?)\s*(g|kg|ml|l)\b/i); let g=0,vol=0;
            if(m){const val=parseFloat(String(m[1]).replace(',','.')); const u=m[2].toLowerCase(); if(u==='kg') g=Math.round(val*1000); if(u==='g') g=Math.round(val); if(u==='l') vol=Math.round(val*1000); if(u==='ml') vol=Math.round(val);}
            const color=extractColor(v.title)||extractColor(v.sku)||null;
            const sel=(String(data.defaultVariantIds?.[i])===String(v.id))?' selected':'';
            html+=`<option value="${v.id}" data-price="${v.price_with_tax}" data-discount="${v.price_with_tax_and_discount}" data-weight-g="${g}" data-volume-ml="${vol}"${color?` data-color="${String(color).replace(/"/g,'&quot;')}"`:''}${sel}>${(v.title||'').replace(/\s*\/\s*$/,'')}</option>`;
          });
          const countLabel=variants.length===1?'1 Sorte':`${variants.length} Sorten`;
          html+=`</select><span class="flavor-count">${countLabel}</span></div></div>`;
        });

        html+=`</div><div class="bundle-content checkbndl"><div class="bundle-details"><div class="bundle-info"><h3>${data.title||''}</h3><div class="bundle-pricing"><div class="price-container"><span class="price-original">${fm(data.compareAtPrice)}</span><span class="price-current">${fm(data.highlightPrice)}</span><span class="discount-badge">-${data.discountTextBase}</span></div><div class="unit-price"></div></div></div></div><button type="button" class="bundle-add-to-cart desktop-only">Jetzt im Set sparen</button><div class="bundle-savings desktop-only">Spare ${data.discountTextBase} - ${fm(data.compareAtPrice-data.highlightPrice)}</div></div></div></form></div>`;

        $c.html(`<div class="bundle-container bundle-container-special">${html}</div>`);
        const $root=$c.find('.bundle-product'); const $form=$root.find('form');

        $root.find('select.bundle-variant-select').each(function(i){
          const desired=S(data.defaultVariantIds?.[i]||$(this).find('option:first').val());
          if(desired){ $(this).val(desired).find('option').prop('selected',false).filter(`[value="${desired.replace(/"/g,'\\"')}"]`).prop('selected',true); }
          setSwatch($(this));
        }).last().trigger('change');

        const ctaText = getDataFirst($c, ['bundle-button-text','cta-label'], 'Jetzt im Set sparen');
        const savingsPrefix = getDataFirst($c, ['savings-prefix'], 'Spare');

        if(slot.type===1){
          if(data.image_src){
            const img=`<div class="bundle-image"><a href="${ctaHref}"><img src="${data.image_src}" alt="${data.title||''}"></a></div>`;
            const $det=$root.find('.bundle-details'); if($det.find('.bundle-info').length) $det.prepend(img); else $det.append(img);
          }
          const $btn=$root.find('button.bundle-add-to-cart.desktop-only');
          if(!openDrawer && asLink){
            if($btn.length) $btn.replaceWith(`<a href="${ctaHref}" class="bundle-add-to-cart desktop-only">${ctaText}</a>`);
          }else{
            if($btn.length) $btn.text(ctaText);
          }
          const mobileHtml = (!openDrawer && asLink)
            ? `<a href="${ctaHref}" class="bundle-add-to-cart mobile-only">${ctaText}</a>`
            : `<button type="button" class="bundle-add-to-cart mobile-only">${ctaText}</button>`;
          $root.find('.bundle-form-container').append(
            `<div class="mobile-cta-container">${mobileHtml}<div class="bundle-savings">${savingsPrefix} ${data.discountTextBase} - ${fm(data.compareAtPrice-data.highlightPrice)}</div></div>`
          );
        }else{
          $root.addClass('special-bundle-layout');
          const override=$c.data('custom-bundle-image'); const finalImg=override||data.image_src||''; const inner=$form.html();
          $form.html(`<div class="split-bundle-container"><div class="bundle-image-column">${finalImg?`<img src="${finalImg}" alt="${data.title||''}">`:''}</div><div class="mobile-view-column">${inner}</div></div>`);
          const $btn2=$root.find('button.bundle-add-to-cart.desktop-only');
          if(!openDrawer && asLink){
            if($btn2.length) $btn2.replaceWith(`<a href="${ctaHref}" class="bundle-add-to-cart desktop-only">${ctaText}</a>`);
          }else{
            if($btn2.length) $btn2.text(ctaText);
          }
          const mobile2 = (!openDrawer && asLink)
            ? `<a href="${ctaHref}" class="bundle-add-to-cart mobile-only">${ctaText}</a>`
            : `<button type="button" class="bundle-add-to-cart mobile-only">${ctaText}</button>`;
          $root.find('.bundle-savings.desktop-only').remove();
          $root.find('.mobile-view-column').append(
            `<div class="mobile-cta-container">${mobile2}<div class="bundle-savings">${savingsPrefix} ${data.discountTextBase} - ${fm(data.compareAtPrice-data.highlightPrice)}</div></div>`
          );
        }

        applyCssVarsToBundle($root);
        $c.find('.unit-price').html(calcUnitPriceText(data.highlightPrice,$form));

        if(typeof window.initCustomSelects==='function') window.initCustomSelects();

        setupPreselect($root,data);

        recalcBundleAndRender($root);

        setTimeout(()=>{ recalcBundleAndRender($root); }, 0);
        setTimeout(()=>{ recalcBundleAndRender($root); }, 120);


        $root.find('select.bundle-variant-select').each(function(){ syncCustomUI($(this)); }).last().trigger('change');

        {
          const isAbs = ['true',true,'1',1].includes($root.data('absolute'));
          const rate  = parseFloat($root.data('discount'))||0;
          const origC = Number(data.compareAtPrice);
          const discC = Number(data.highlightPrice);
          const discountText = isAbs ? Shopify.api.formatMoney(Math.ceil(Math.max(0,origC-discC)), window.theme.moneyFormat) : Math.ceil(rate*100)+'%';
          toggleDiscountUI($root, origC, discC, discountText, savingsPrefix);
        }

        $root.off('click.bundleAjax').on('click.bundleAjax','.bundle-add-to-cart',async function(e){
          if(!openDrawer && asLink && this.tagName==='A') return;
          e.preventDefault(); e.stopPropagation();
          const $f=$root.find('form.bundle-form'); $f.addClass('is-loading');
          try{prepareBundleFormForShopifyAnalytics($f[0]);}catch{} try{trackBundleSubmitSafe($f[0]);}catch{}
          try{
            await ajaxAddBundle($f,sectionList);
            let ok=false; try{ok=await refreshCartDrawerFromCartSection();}catch{} if(!ok) try{ok=await refreshCartDrawerFallbackFromCartPage();}catch{}
            let d=document.querySelector('#sidebar-cart')||document.querySelector('.Drawer'); d=bootstrapDrawerSkeleton(d)||d; ensureFooterWithTotals(d,'after-add'); bindDrawerCloseButtonsOnce(d);
            openCartDrawerAdvanced(drawerSel);
          }catch(err){console.error('[Bundles] ajax add failed',err);}
          finally{$f.removeClass('is-loading'); removeRedirectGuardsSoon();}
        });

        used.add(data.id);
      }

      slots.forEach((slot,idx)=>{ if(!slot.$el||!slot.$el.length) return; const chosen=slot.id?(pickById(slot.id)||pickNext()):pickNext(); if(chosen) buildAndMount(idx,chosen); });

      $(document).off('change.bundleSelect').on('change.bundleSelect','.bundle-variant-select',function(){
        const $bp=$(this).closest('.bundle-product'); const $form=$(this).closest('form');
        const isAbs=['true',true,'1',1].includes($bp.data('absolute')); const rate=parseFloat($bp.data('discount'))||0;
        let orig=0,disc=0; $form.find('select.bundle-variant-select').each(function(){const opt=$(this).find('option:selected'); orig+=(parseFloat(opt.data('price'))||0)*100; disc+=(parseFloat(opt.data('discount'))||0)*100;});
        const discountText=isAbs?Shopify.api.formatMoney(Math.ceil(Math.max(0,orig-disc)),window.theme.moneyFormat):Math.ceil(rate*100)+'%';

        const $slot=$bp.closest('#ProductBundles2, #ProductBundles1');
        const pref=getDataFirst($slot, ['savings-prefix'], 'Spare');

        toggleDiscountUI($bp, orig, disc, discountText, pref);

        $bp.find('.price-original').html(Shopify.api.formatMoney(orig,window.theme.moneyFormat));
        $bp.find('.price-current').html(Shopify.api.formatMoney(disc,window.theme.moneyFormat));
        $bp.find('.unit-price').html(calcUnitPriceText(disc,$form));

        setSwatch($(this)); syncCustomUI($(this));
      });

      try{ warmCartSections(); }catch{}

      $(document)
        .off('mouseenter.bundleWarm touchstart.bundleWarm', '#ProductBundles1 .bundle-add-to-cart, #ProductBundles2 .bundle-add-to-cart')
        .on('mouseenter.bundleWarm touchstart.bundleWarm', '#ProductBundles1 .bundle-add-to-cart, #ProductBundles2 .bundle-add-to-cart', function(){ try{warmCartSections();}catch{} });

      bindOverlayClickOnce(); bindDrawerCloseButtonsOnce(); groupEnd();
    })
    .fail(function(){dbg('bundles-load-fail'); groupEnd();});

  // expose helpers
  window.refreshCartDrawerFromCartSection=refreshCartDrawerFromCartSection;
  window.refreshCartDrawerFallbackFromCartPage=refreshCartDrawerFallbackFromCartPage;
  window.normalizeDrawerMarkup=normalizeDrawerMarkup;
  window.ensureFooterWithTotals=ensureFooterWithTotals;
  window.bootstrapDrawerSkeleton=bootstrapDrawerSkeleton;
}
